import React from 'react';
import { TChildren } from '../../../typings/common';
import styles from './ToolbarControls.module.scss';

interface Props {
  children: TChildren;
}

const ToolbarControls: React.FC<Props> = ({ children }) => (
  <div className={styles.toolbarControls}>{children}</div>
);

export default ToolbarControls;
